export default __webpack_public_path__ + "static/media/1994.52c02c25.png";